import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AutenticationService } from '../../autentication/autentication.service';
import { Auth } from '../../autentication/Auth';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { EventTypes } from '../EventTypes';
import { SharedService } from '../shared.service';

@Component({
	selector: 'app-signature-with-steps',
	templateUrl: './signature-with-steps.component.html',
	styleUrls: ['./signature-with-steps.component.styl'],
	encapsulation: ViewEncapsulation.None
})

export class SignatureWithStepsComponent implements OnInit {
	@Input() disabled = false;
	@Input() disabledFinishButton = false;
	@Input() submited: boolean;
	@Input() showTokenInput = true;
	@Input() showFooter = true;
	@Input() firstPrevButtonRerenderPage = false;
	@Input() firstPrevButtonRouterName = '';
	@Input() labelLastButton = '';
	@Input() labelPrevButton = 'Voltar';
	@Input() prevButtonSendsEventToParent = false;
	@Output() onSetForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
	@Output() sendFormInSetter = new EventEmitter<boolean>();
	@Output() pressedCancelButton = new EventEmitter<boolean>();

	public step = 1;
	public firstStep = 1;
	public lastStep = 2;
	public title = '';
	public labelNextButton = 'Próximo';
	public form: FormGroup;
	public isTransactionUser = false;
	public inputToKeypadSendValue: any;
	public tokenMessage: string;

	constructor(
		private formBuilder: FormBuilder,
		private authService: AutenticationService,
		private sharedService: SharedService,
		private router: Router) {
	}

	ngOnInit(): void {
		this.initForm();
		this.setIsTransactionUser();
		this.setTitleAndLabelButton();
		this.setInputTarget();
		this.sendEvents();
		this.setFormControls();
		this.updateLastStep();
		this.sendSmsToken();
	}

	private sendEvents() {
		this.sendFormInSetter.emit(false);
		this.onSetForm.emit(this.form);
	}

	private updateLastStep() {
		if (!this.isTransactionUser) {
			this.lastStep = 1;
		}
	}

	private setFormControls() {
		if (this.isTransactionUser) {
			this.form.addControl('token', new FormControl('', Validators.required));
		} else {
			if (this.form.controls.token) {
				this.form.removeControl('token');
			}
		}
	}

	private setIsTransactionUser() {
		this.isTransactionUser = Auth.getInstance().getUser().rule === 'TRANSACIONAR' && this.showTokenInput;
	}

	private initForm() {
		this.form = this.formBuilder.group({
			'eletronicSignature': ['', Validators.required]
		});
	}

	sendSmsToken() {
		if (Auth.getInstance().getUser().tokenSms) {
			AppEventDispatcher.dispatch(EventTypes.PRELOAD, { show: true });
			this.authService.requestTokenSMS().subscribe((data: any) => {
				this.tokenMessage = data.Mensagem;
				AppEventDispatcher.dispatch(EventTypes.PRELOAD, { show: false });
			}, () => {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK,
					{ msg: 'Erro ao solicitar token por SMS, por favor, clique no botão reenviar token.' });
			});
		}
	}

	setTitleAndLabelButton() {
		switch (this.step) {
			case 1:
				this.title = 'Digite sua assinatura eletrônica';
				this.labelNextButton = (this.isTransactionUser ? 'Próximo' : 'Finalizar');
				break;
			case 2:
				this.title = 'Digite o token';
				this.labelNextButton = this.labelLastButton === '' ? 'Finalizar' : this.labelLastButton;
				break;
		}
	}

	setInputValueFromKeyPad(val: Array<number>) {
		if (this.inputToKeypadSendValue.value.length < 6) {
			this.inputToKeypadSendValue.setValue(this.inputToKeypadSendValue.value.toString() + val[0].toString());
		}
	}

	setInputTarget() {
		if (this.step === 2) {
			this.inputToKeypadSendValue = this.form.get('token');
		} else {
			this.inputToKeypadSendValue = this.form.get('eletronicSignature');
		}
	}

	onCorrect() {
		this.inputToKeypadSendValue.setValue('');
	}

	prev() {
		if (this.step === this.firstStep) {
			this.executeFirstPrevButton();
		} else {
			this.step--;
			this.setTitleAndLabelButton();
			this.setInputTarget();
		}
	}

	private executeFirstPrevButton() {
		if (this.prevButtonSendsEventToParent) {
			this.pressedCancelButton.emit(true);
			return;
		}

		if (this.firstPrevButtonRerenderPage) {
			this.sharedService.changeRerender(true);
		} else if (this.firstPrevButtonRouterName.length > 0) {
			this.router.navigate([this.firstPrevButtonRouterName]);
		}
	}

	next() {
		if (this.step === this.lastStep) {
			this.sendForm();
		} else {
			this.step++;
			this.setTitleAndLabelButton();
			this.setInputTarget();
		}
	}

	sendForm() {
		this.submited = true;

		if (this.form.valid) {
			this.sendFormInSetter.emit(true);
			this.onSetForm.emit(this.form);
		}
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/signature-with-steps/signature-with-steps.component.ts